// extracted by mini-css-extract-plugin
export default {"collateral":"styles_collateral__P1Fwu"};